import React, { useEffect } from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <h2>Book Your Appointment - Available 24/7</h2>
        <div className="contact-grid">
          <div className="calendly-container">
            <div 
              className="calendly-inline-widget" 
              data-url="https://calendly.com/emmanuelibenye/notary-public-express-service" 
              style={{ minWidth: '320px', height: '700px' }}
            ></div>
          </div>

          <div className="contact-info">
            <h3>Contact Information</h3>
            <p><strong>Phone:</strong> <a href="tel:+14374490147">(437) 449-0147</a></p>
            <p><strong>Email:</strong> <a href="mailto:info@notarypublicexpress.ca">info@notarypublicexpress.ca</a></p>
            <p>
              <strong>Service Area:</strong><br />
              Licensed to serve all of Ontario
            </p>
            <p>
              <strong>🕐 24/7 Service Hours</strong><br />
              Available around the clock for urgent notarization needs
            </p>
            <p>
              <strong>Available Services:</strong><br />
              • Document Notarization<br />
              • Legal Document Drafting<br />
              • Immigration & Visa Services<br />
              • Business & Corporate Services<br />
              • International Documents<br />
              • Mobile & Online Appointments
            </p>
            <p>
              Select a convenient time slot from the calendar to book your notary appointment. 
              We offer both online and in-person services 24/7 to meet your urgent needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;